export default "__VITE_ASSET__DS99sXi5__"